<template>
  <base-popup
      :popup-model="show"
      title="Merged Invoice Mail Template"
      :valid="!valid"
      :width="45"
      :show-save-button="false"
      @onCancelButtonClick="closeMailPopupHandler"
  >
    <v-card class="mt-5">
      <v-card-text id="myInput" class="mail-text-weight">
        <p>
          {{ getTitle(mailTemplate.title) }}<br><br>
          {{ mailTemplate.liveLinkText }}: {{getRefLink(currentItem.mergedNo)}}<br><br>
          <span class="mail-text-black">{{ mailTemplate.stepTitle }}</span><br>
        </p>
        <span v-for="item in mailTemplate.steps" :key="item">{{item}}<br></span>
        <br>
        <p class="mail-text-black">{{ mailTemplate.note }}</p>
      </v-card-text>
    </v-card>
  </base-popup>
</template>

<script>
import BasePopup from "@/components/popups/BasePopup";
import Popup from "../mixins/Popup";
import mailTemplate from "../../json/mailTemplate.json"
export default {
  name: "MergedInvoiceMailTemplate",
  mixins: [Popup],
  components: {BasePopup},
  data() {
    return {
      selectedItem: 0,
      mailTemplate: mailTemplate
    }
  },
  methods: {
    getTitle(title) {
      let ids = [];
      if(!this.currentItem.merged_invoice_details) {
        return title.replaceAll('type', '');
      }

      this.currentItem.merged_invoice_details.forEach((item) => {
        ids.push(item.invoice_details.invoiceNo)
      })
      return title.replaceAll('type', `Invoice No.: ${ids.toString()}`);
    },
    getRefLink(refcode) {
      const api = process.env.VUE_APP_BASE_URL;
      return `${api}/payment?refno=${refcode}`;
    },
    closeMailPopupHandler() {
      this.$emit('closeMailPopupHandler');
    },
  }
}
</script>

<style scoped>

</style>